module.exports = __webpack_public_path__ + "static/media/bell.79961766.svg";